import { render, staticRenderFns } from "./weekdays_numerical_addon.vue?vue&type=template&id=0533573c&scoped=true"
import script from "./weekdays_numerical_addon.vue?vue&type=script&lang=js"
export * from "./weekdays_numerical_addon.vue?vue&type=script&lang=js"
import style0 from "./weekdays_numerical_addon.vue?vue&type=style&index=0&id=0533573c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533573c",
  null
  
)

export default component.exports